var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.employees && _vm.employees.length)?_c('span',{staticClass:"tags",class:{centered: _vm.centered}},_vm._l((_vm.employees),function(employee){return _c('span',{staticClass:"tag is-warning",class:_vm.size},[_vm._v(_vm._s(_vm._f("nameShortify")(employee)))])}),0):_c('span',[_c('span',{staticClass:"tag"},[_vm._v("not available")])])
}
var staticRenderFns = []

export { render, staticRenderFns }